module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "ch1",
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "CT"
  }, [_c('span', {
    attrs: {
      "aria-label": "1",
      "id": "pg_1",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch1",
      "id": "ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('i', [_vm._v("Introduction")])])])])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "V"
  }, [_vm._v("I decided to write this book after being")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("asked so many times how my first book,")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_c('i', [_vm._v("Abandoned Breaths,")]), _vm._v(" began.")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('i', [_vm._v("Silent Squall")]), _vm._v(" touches upon emotional and")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("physical abuse. It deals with the horror")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("of finding yourself in the middle of a life")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("that is ruthlessly controlled by "), _c('i', [_vm._v("the one")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("who professes to love you. Your mind and")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("your body become bent—always at the beck")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("and call of the "), _c('i', [_vm._v("watchman.")]), _vm._v(" You"), _c('i', [_vm._v("r")]), _vm._v(" self-worth")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("is discarded because he strives hard to")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("make sure you are void of it. You are")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("broken down, sliced in slivers, and each")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("day of this becomes your normalcy … "), _c('i', [_vm._v("yet")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('i', [_vm._v("you know it is not normal.")]), _vm._v(" You hide from")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("friends behind smoke and mirrors, because")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("no one can know the truth. They might think")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("you deserved it. You’ve become weak, but")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("this is his plan. "), _c('i', [_vm._v("That way you cannot flee.")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("One day you will determine that anything")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("is better than not wanting to live")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("anymore. "), _c('i', [_vm._v("And somehow you gain the")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('i', [_vm._v("courage to fly.")]), _vm._v(" You may do it silently in")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("the middle of the night or you may require")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("law enforcement or friends and family to")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("guard your back … "), _c('i', [_vm._v("but you fly.")]), _vm._v(" You sever")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('span', {
    attrs: {
      "aria-label": "2",
      "id": "pg_2",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("the legal ties, yet the struggle continues")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("because the road to freedom is long and")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("your abuser is vicious.")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("These poems and quotes are about a")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("journey. An ongoing pilgrimage of finding")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("the person I lost in the storm 30 years ago.")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("Many of these quotes and poems were first")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("written in a journal I began while in")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("therapy. It is my hope that if you are in")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("any situation similar to this that you "), _c('i', [_vm._v("tell")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('i', [_vm._v("someone.")]), _vm._v(" I hope that this book gives you")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("the courage to take flight and to begin")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("living again.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed11cd74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter1.vue
// module id = 69
// module chunks = 0